import { useNavigate } from "react-router-dom";
import AssociateAccountEdit from "../../../../../containers/Accounts/BeneficiaryEditAccount/AssociateAccountEdit";
import GSTVerification from "../../../../../containers/Settings/GSTDetails";
import GstDetails from "../../../../_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../_utils/AccountCreationComponents/PanDetails";
import LargePopupRedirect from "../../../../_utils/CommonPopups/CommonLargePopupRedirect";
import TaxAccountDetailsPopup from "../../TaxAccountDetailsPopup";

const TaxAccoountEditStepPAN = ({
  verifiedPan,
  panNumber,
  handlePANChange,
  panDetails,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  setAccountType,
  type,
  id,
  setIsActive,
  isActive,
  setNewMessage,
  setHideBlock,
  isLinkedAccount,
  setIsLinkedAccount,
  alreadyLinked,
  haveLinkNew,
  payload,
  setShowAccInfo,
  setSlideDirection,
  handleGSTChange,
  GSTStatus,
  GSTLinked,
  GSTError,
  gstVerified,
  isGSTLoading,
  gstDetails,
  activeTab,
  setActiveTab,
  taxAccountId,
  setTaxAccountId,
  taxAccountDetails,
  setTaxAccountDetails,
  showPopup,
  setShowPopup,
  haveAcheived,
  haveApproved,
  haveBlock,
  haveDennied,
  havePending,
  haveRejected,
  slideDirection,
  isApprovedState,
  noDetails,
  closeGSTDetailsModal,
  beneLookLoading,
  prefilledGst,
}) => {
  const navigate = useNavigate();

  const isGSTDisabled = !panNumber || !verifiedPan;

  const ActiveData = () => {
    setIsActive(false);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    if (activeTab === "Inactive") setSlideDirection("left");
    setActiveTab("Active");
    setIsPending(false);
    if (haveLinkNew && type === "editFlow") {
      setIsLinkedAccount(true);
      setNewMessage(false);
    } else {
      setIsLinkedAccount(false);
    }
    setAccountType({
      type: "",
      id: "",
    });
    setHideBlock(false);
    setShowAccInfo(false);
  };

  const DeactiveData = () => {
    setIsActive(true);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    setIsPending(false);
    if (activeTab === "Active") setSlideDirection("right");
    setActiveTab("Inactive");

    if (haveLinkNew && type === "editFlow") {
      setIsLinkedAccount(true);
      setNewMessage(false);
    } else {
      setIsLinkedAccount(false);
    }
    setShowAccInfo(false);
    setAccountType({
      type: "",
      id: "",
    });
  };

  const addSpacesToNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  return (
    <>
      {taxAccountDetails && (
        <>
          <TaxAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setTaxAccountDetails(false);
            }}
            tax_account_id={taxAccountId}
            type={"tax_account_detail_modal"}
          />
        </>
      )}
      {showPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal Qmd:bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="GST Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate("/settings/GST_verification", {
                state: gstDetails?.gstin_details?.gstin_no,
              })
            }
            closeiconhandleFunction={() => setShowPopup(false)}
          >
            <GSTVerification
              gst_number={gstDetails?.gstin_no}
              closeGSTDetailsModal={closeGSTDetailsModal}
              popup={true}
              setShowPopup={setShowPopup}
              showPopup={showPopup}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div className="w-full flex flex-col items-center Qlg:flex-row Qlg:justify-between Qlg:items-start overflow-y-auto">
        <div className="max-w-tab-width-normal mx-auto flex flex-col Qlg:flex-row gap-gap-md Qlg:gap-gap-xl py-padding-md w-full">
          <div className="w-full px-padding-md Qlg:px-padding-base Qlg:w-width-md">
            {(isLinkedAccount || alreadyLinked) && verifiedPan && (
              <div className="p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md">
                <p className="text-text-secondary text-font-xs ">
                  Looks like this PAN is already linked to this account. Please
                  change provided PAN details to proceed.
                </p>
              </div>
            )}

            {prefilledGst && (
              <div className="p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md">
                <h5 className=" text-text-primary text-font-sm font-semibold">
                  Since GST and PAN are linked
                </h5>
                <ul className="list-disc text-font-xs text-text-primary pl-padding-button-l">
                  <li className="my-margin-sm">
                    To edit PAN, the associated GST must also be provided.
                  </li>
                  <li>
                    GST can only be replaced with other GSTs that are associated
                    with the provided PAN.
                  </li>
                </ul>
              </div>
            )}

            <div className="h-auto mb-margin-md">
              <PanDetails
                verifiedPan={verifiedPan}
                verifyPANisLoading={verifyPANisLoading}
                panNumber={panNumber}
                handlePanChange={handlePANChange}
                panDetails={panDetails}
              />
            </div>

            <div
              className="h-auto rounded-border-radius-md"
              style={{
                pointerEvents: isGSTDisabled ? "none" : "auto",
                cursor: isGSTDisabled ? "not-allowed" : "text",
                opacity: isGSTDisabled
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
              }}
            >
              <GstDetails
                GSTStatus={GSTStatus}
                gstVerified={gstVerified}
                GSTLinked={GSTLinked}
                beneVerifyGST={{
                  status: GSTStatus,
                  gstin_details: gstDetails,
                  errors: GSTError,
                }}
                isGSTLoading={isGSTLoading}
                GstNumber={payload.gstin}
                setShowPopup={setShowPopup}
                handleChange={handleGSTChange}
              />
            </div>
          </div>

          <div className="w-width-full flex flex-col h-auto Qlg:w-width-md relative">
            {verifiedPan === true ? (
              <div className="w-full flex flex-col flex-1">
                <div className="flex-1">
                  <div className="mx-margin-md Qlg:mx-margin-base">
                    <AssociateAccountEdit
                      ActiveData={ActiveData}
                      DeactiveData={DeactiveData}
                      haveAcheived={haveAcheived}
                      haveDennied={haveDennied}
                      haveBlock={haveBlock}
                      haveRejected={haveRejected}
                      isApprovedState={isApprovedState}
                      haveApproved={haveApproved}
                      havePending={havePending}
                      isActive={isActive}
                      activeTab={activeTab}
                      setSlideDirection={setSlideDirection}
                      slideDirection={slideDirection}
                      setActiveTab={setActiveTab}
                      previousId={id}
                      addSpacesToNumber={addSpacesToNumber}
                      beneLookLoading={beneLookLoading}
                      verifiedPan={verifiedPan}
                      details={noDetails}
                      setAccountId={setTaxAccountId}
                      setAccoutDetails={setTaxAccountDetails}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full max-w-totp-box-width invisible"></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxAccoountEditStepPAN;
